import {FAILURE, PENDING, SUCCESS} from '../../constants'

const ACTION = 'GET_AUDITS'

export const GAS_FAILURE = `${ACTION}_${FAILURE}`
export const GAS_PENDING = `${ACTION}_${PENDING}`
export const GAS_SUCCESS = `${ACTION}_${SUCCESS}`

const ACTIONNEXTAUDITS = 'GET_NEXT_AUDITS'

export const GNAS_FAILURE = `${ACTIONNEXTAUDITS}_${FAILURE}`
export const GNAS_PENDING = `${ACTIONNEXTAUDITS}_${PENDING}`
export const GNAS_SUCCESS = `${ACTIONNEXTAUDITS}_${SUCCESS}`

const ACTIONITEMSCOUNT = 'GET_ITEMS_COUNT'

export const GACS_FAILURE = `${ACTIONITEMSCOUNT}_${FAILURE}`
export const GACS_PENDING = `${ACTIONITEMSCOUNT}_${PENDING}`
export const GACS_SUCCESS = `${ACTIONITEMSCOUNT}_${SUCCESS}`

const DELETE_ACTION = 'DELETE_AUDITS'

export const DA_FAILURE = `${DELETE_ACTION}_${FAILURE}`
export const DA_PENDING = `${DELETE_ACTION}_${PENDING}`
export const DA_SUCCESS = `${DELETE_ACTION}_${SUCCESS}`

const GET_ACTION = 'GET_AUDIT'

export const GA_FAILURE = `${GET_ACTION}_${FAILURE}`
export const GA_PENDING = `${GET_ACTION}_${PENDING}`
export const GA_SUCCESS = `${GET_ACTION}_${SUCCESS}`

const UPDATE_ACTION = 'UPDATE_AUDIT'

export const UA_FAILURE = `${UPDATE_ACTION}_${FAILURE}`
export const UA_PENDING = `${UPDATE_ACTION}_${PENDING}`
export const UA_SUCCESS = `${UPDATE_ACTION}_${SUCCESS}`

const CREATE_ACTION = 'CREATE_AUDIT'

export const CA_FAILURE = `${CREATE_ACTION}_${FAILURE}`
export const CA_PENDING = `${CREATE_ACTION}_${PENDING}`
export const CA_SUCCESS = `${CREATE_ACTION}_${SUCCESS}`
